import { render, staticRenderFns } from "./processProducts.vue?vue&type=template&id=18c57b0f&scoped=true&"
import script from "./processProducts.vue?vue&type=script&lang=js&"
export * from "./processProducts.vue?vue&type=script&lang=js&"
import style0 from "./processProducts.vue?vue&type=style&index=0&id=18c57b0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c57b0f",
  null
  
)

export default component.exports